import { a as r } from "../internals/array-buffer-view-core.js";
import { t as a } from "../internals/typed-array-species-constructor.js";
import { f as e } from "../internals/fails.js";
import { a as s } from "../internals/array-slice.js";
var t = r.aTypedArray;
(0, r.exportTypedArrayMethod)("slice", function (r, e) {
  for (var i = s(t(this), r, e), n = a(this), o = 0, f = i.length, c = new n(f); f > o;) c[o] = i[o++];
  return c;
}, e(function () {
  new Int8Array(1).slice();
}));